module.exports = __webpack_public_path__ + "img/holland-eredivisie-16.43f7cecc.png";